import React from 'react'
import './Note.css';

function Note({style, text, link, onClick}) {
    const className = "NoteText " + style;
    return (
        <p className={className}>{text} <span onClick={onClick} className="NoteLink">{link}</span></p>
    )
}

export default Note;
